export const environment = {
  backendUrl: "https://api.test.leaplegalaid.co.uk/api",
  dateFormat: "DD/MM/YYYY",
  currencyPrefix: "£",
  clientId: "4S65SCOIEAD62GNW",
};
